import { __exports as o } from "../../../_virtual/well-known-symbol-wrapped.js";
import { w as l } from "./well-known-symbol.js";
o.f = l;
export { o as default };